import React from 'react';
import { Paper, Tooltip } from '@material-ui/core';

// Scans per showroom location. Only meaningful for multi-location accounts;
// hidden when there's a single (or no) location in the data.
const LocationComparison = ({ locations }) => {
  const list = locations || [];
  if (list.length <= 1) return null;

  const max = list.reduce((m, l) => Math.max(m, l.scans), 0);

  return (
    <Paper className="insights__card insights__col-6" variant="outlined">
      <div className="insights__card-head">
        <span className="insights__card-title">Scans by Location</span>
        <span className="insights__card-sub">showroom comparison</span>
      </div>
      {list.map((l) => (
        <div className="insights__bar-row" key={l.location_id ?? 'unknown'}>
          <Tooltip title={l.location_name}>
            <span className="insights__bar-name">{l.location_name}</span>
          </Tooltip>
          <span className="insights__bar-track">
            <span
              className="insights__bar-fill"
              style={{ width: `${max ? (l.scans / max) * 100 : 0}%` }}
            />
          </span>
          <span className="insights__bar-val">{l.scans}</span>
        </div>
      ))}
    </Paper>
  );
};

export default LocationComparison;
